import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=73e090a0&scoped=true"
import script from "./workspace.vue?vue&type=script&lang=js"
export * from "./workspace.vue?vue&type=script&lang=js"
import style0 from "./workspace.vue?vue&type=style&index=0&id=73e090a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e090a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e090a0')) {
      api.createRecord('73e090a0', component.options)
    } else {
      api.reload('73e090a0', component.options)
    }
    module.hot.accept("./workspace.vue?vue&type=template&id=73e090a0&scoped=true", function () {
      api.rerender('73e090a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/workspace.vue"
export default component.exports